import React, { useEffect, useRef, useState } from "react";
import { beginnerBannerText, getScreenSize, getAdjustingFontSizeByHeightWidth, isSafari, getIsMobile } from "../globalConstants";
import DelighterStill from "../assets/playStoreDelighterTop10pcimage.webp"
import GamePlayScreenShot from "../assets/gamePlayScreenShot.webp"
import StoreCreativeBackground from '../assets/storeCreativeBackgrounds3.png';
import StoreCreativeBackgroundNarrow from '../assets/storeCreativeBackgroundsNarrow1.png';
import ReviewScreen from "../assets/reviewScreen.webp"
import { FlexiblePhone, FlexiblePhoneStillImage } from "./flexiblePhone";
import { backgroundDiv } from "./leadSection";
import gameScreen from "../assets/gamePlayVideo1.mp4";
import delighter from "../assets/delighterVideoJun26.mp4";
import resultsScreen from "../assets/resultsScreen.mp4"
import { navbarState } from "./navbarState";
export const HowItWorksSection: React.FC = () => {
    const screen = getScreenSize();
    const heightReference = screen.height;
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    useEffect(() => {
        navbarState.setHidden(hoveredIndex !== null);
    }, [hoveredIndex]);

    // Cleanup on unmount
    useEffect(() => {
        return () => navbarState.setHidden(false);
    }, []);
    const steps = [
        {
            number: "1",
            title: "Play Deals",
            text: "Navigate thought-provoking deals with no time pressure",
            image: GamePlayScreenShot,
            video: gameScreen
        },
        {
            number: "2",
            title: "See Rank & Mistakes",
            text: "Instant ranking and solver evaluation of your play",
            image: DelighterStill,
            video: delighter
        },
        {
            number: "3",
            title: "Review Your Game",
            text: "Delve into analysis that is clear, organized and skill-level matched",
            image: ReviewScreen,
            video: resultsScreen,
            banner: beginnerBannerText
        }
    ];

    const isMobileOrTablet = false;



    const phoneBorderRadius = !isMobileOrTablet ? getScreenSize().height * 0.1 : 35
    // Video refs to control playback
    const videoRefs = useRef<(HTMLVideoElement | null)[]>([null, null, null]);
    const [videoKeys, setVideoKeys] = useState([0, 0, 0]); // Force re-render of videos


    // Function to replay video when it comes to middle
    const handleVideoReplay = (hoveredIndex: number) => {
        const video = videoRefs.current[hoveredIndex];
        if (video) {
            video.currentTime = 0;
            video.play().catch(e => console.log("Video play failed:", e));
        }
    };

    // Effect to handle video replay when rotation state changes
    useEffect(() => {
        // Small delay to ensure the video is in the middle position
        const timer = setTimeout(() => {
            handleVideoReplay(hoveredIndex);
        }, 100);

        return () => clearTimeout(timer);
    }, [hoveredIndex]);

    useEffect(() => {
        let startScrollY = window.scrollY;

        const handleScroll = () => {
            if (Math.abs(window.scrollY - startScrollY) > 400 && window.scrollY > 1200) {
                setHoveredIndex(null);
                startScrollY = window.scrollY; // reset so it doesn't keep firing
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            style={{
                width: "100%",
                height: heightReference * 0.9,
                paddingTop: "2%",
                paddingBottom: "6%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "linear-gradient(180deg, rgb(255, 246, 210) 0%, rgb(255, 235, 160) 100%)",
                position: "relative",
            }}
        >
            {<img
                src={isMobileOrTablet ? StoreCreativeBackgroundNarrow : StoreCreativeBackground}
                alt="Daily Tournament Tile"
                style={{
                    width: "100%",
                    height: '100%',
                    objectFit: 'cover',
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 0
                }}
            />}

            {/* Page Title */}
            <h1
                style={{
                    fontFamily: "Bold",
                    fontSize: getAdjustingFontSizeByHeightWidth(
                        heightReference * 0.05,
                        screen.width * 0.6,
                        "How it Works".length,
                        200
                    ),
                    color: "rgba(51, 41, 0, 1)",
                    marginTop: "1%",
                    marginBottom: "1%",
                    textAlign: "center",
                    WebkitTextStroke: isSafari ? "0.5px rgba(50, 50, 0, 0.6)" : null,
                    textShadow: isSafari ? null : "1px 1px 0px rgb(50, 50, 0)",
                }}
            >
                Simple and Fun
            </h1>

            {/* 3 Columns */}
            <div
                style={{
                    width: "80%",
                    display: "flex",
                    flexDirection: screen.width < 900 ? "column" : "row",
                    justifyContent: "space-between",
                    gap: 0
                }}
            >
                {hoveredIndex != null &&
                    <div style={{ position: "absolute", left: "-20%", top: "-110%", height: "300%", width: "190%", backgroundColor: "rgba(0,0,0,0.51)", zIndex: 9 }}></div>
                }
                {steps.map((step, index) => {
                    const isHovered = hoveredIndex === index;

                    return (
                        <div
                            key={index}

                            onMouseOver={() => { setHoveredIndex(index) }}
                            onMouseLeave={() => setHoveredIndex(null)}
                            style={{
                                flex: 1,
                                margin: "1%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                textAlign: "center",
                                position: "relative",
                                transform: isHovered ? "scale(1.06) translateY(5%)" : "scale(1)",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                zIndex: isHovered ? 10 : 1,

                            }}
                        >
                            {/* Card Background */}
                            <div
                                style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "24px",
                                    opacity: isHovered ? 0 : 1,
                                    background: "linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 60%, rgb(255, 240, 180) 100%)",
                                    boxShadow: isHovered
                                        ? `0 16px 48px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.10)`
                                        : `0 8px 32px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04)`,
                                    border: "1px solid rgba(255,255,255,0.6)",
                                    transition: "box-shadow 0.3s ease",
                                }}
                            />

                            {/* Hover Overlay */}
                            <div
                                style={{
                                    position: "absolute",
                                    width: "100%",
                                    pointerEvents: "none",
                                    height: "125%",
                                    borderRadius: "24px",
                                    background: "linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 60%, rgb(255, 240, 180) 100%)",
                                    boxShadow: isHovered
                                        ? `0 16px 48px rgba(0, 0, 0, 0.18), 0 8px 24px rgba(0, 0, 0, 0.10)`
                                        : `0 8px 32px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04)`,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "flex-start",  // <-- was "center"
                                    // <-- push content down from top edge
                                    padding: "1%",
                                    boxSizing: "border-box",
                                    opacity: isHovered ? 1 : 0,
                                    transition: "opacity 0.3s ease",
                                    zIndex: 5,
                                    bottom: 0,
                                }}
                            >
                                {/* Title */}
                                <div
                                    style={{
                                        fontFamily: "Bold", width: "100%", position: "relative", display: "flex", justifyContent: "center", alignItems: "center",
                                        fontSize: getAdjustingFontSizeByHeightWidth(
                                            heightReference * 0.085,
                                            screen.width * 0.16,
                                            step.title.length,
                                            200
                                        ),
                                        color: "rgba(51, 41, 0, 1)",
                                        paddingLeft: "3%", paddingRight: "3%",
                                        marginTop: "10%",
                                        marginBottom: "5%",
                                        opacity: isHovered ? 1 : 0,
                                        transform: isHovered ? "translateY(0%)" : "translateY(32%)",
                                        transition: "transform 0.4s ease",
                                    }}
                                >
                                    {step.title}
                                </div>
                                {/* Phone image — slides up on hover */}
                                <div
                                    style={{
                                        minHeight: heightReference * 0.29 * 2.02535,
                                        height: heightReference * 0.29 * 2.02535,
                                        maxHeight: heightReference * 0.29 * 2.02535,
                                        width: heightReference * 0.29, marginBottom: "5%",
                                        minWidth: heightReference * 0.29,
                                        maxWidth: heightReference * 0.29,
                                        transform: isHovered ? "translateY(0%)" : "translateY(8%)",
                                        transition: "transform 0.4s ease"
                                    }}
                                >
                                    <FlexiblePhone
                                        style={{ width: "100%", height: "100%", position: "relative" }}
                                        videoBorderRadius={heightReference * 0.06}
                                        marginHorizontal={"3%"}
                                        marginTop={"1%"}
                                        video={step.video}
                                        videoRef={(ref) => videoRefs.current[index] = ref}
                                        videoKey={videoKeys[index]}
                                        banner={step.banner}
                                    />
                                </div>

                                {/* Descriptive text — fades in slightly after */}
                                <div
                                    style={{
                                        fontFamily: "Bold",
                                        flex: 1,
                                        margin: 0,
                                        marginBottom: "6%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-end",

                                        fontSize: getAdjustingFontSizeByHeightWidth(
                                            heightReference * 0.06,
                                            screen.width * 0.23,
                                            step.text.length,
                                            200
                                        ),
                                        // background: "linear-gradient(0deg, rgba(63, 51, 25, 0.95) 0%, rgba(63, 51, 25, 0.6) 70%, rgba(63, 51, 25, 0) 100%)",
                                        color: "rgba(51, 41, 0, 1)",
                                        paddingLeft: "5%", paddingRight: "5%",
                                        lineHeight: 1.5,
                                        textAlign: "center",
                                        opacity: isHovered ? 1 : 0,
                                        transform: isHovered ? "translateY(0%)" : "translateY(20%)",
                                        transition: "opacity 0.4s ease 0.15s, transform 0.4s ease 0.15s",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    {step.text}
                                </div>
                                {/* Curved background blob */}
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: 0,
                                        width: "100%",
                                        background: "rgba(204, 190, 131, 0.95)",
                                        borderRadius: "60% 40% 24px 24px / 40px 40px 24px 24px",
                                        padding: `${(36 - Math.round(18 * screen.width / 1920)).toString() + "%"} 10% 10% 10%`,
                                        //boxShadow: "0 -4px 20px rgba(0,0,0,0.08)",
                                        zIndex: -1
                                    }}
                                >
                                    <div
                                        style={{

                                            fontFamily: "Medium",
                                            fontSize: getAdjustingFontSizeByHeightWidth(
                                                heightReference * 0.03,
                                                screen.width * 0.18,
                                                step.text.length,
                                                48
                                            ),
                                            color: "rgba(51, 41, 0, 1)",
                                            lineHeight: 1.5,
                                            textAlign: "center",
                                            boxSizing: "border-box",
                                        }}
                                    >

                                    </div>
                                </div>
                            </div>
                            {/* Dark Gold Number Circle */}
                            <div
                                style={{
                                    width: 1.5 * getAdjustingFontSizeByHeightWidth(
                                        heightReference * 0.03,
                                        screen.width * 0.03,
                                        step.number.length,
                                        64
                                    ),

                                    height: 1.5 * getAdjustingFontSizeByHeightWidth(
                                        heightReference * 0.03,
                                        screen.width * 0.03,
                                        step.number.length,
                                        64
                                    ),
                                    opacity: isHovered ? 0 : 1,
                                    position: "absolute",
                                    top: isHovered ? "-12%" : "-2%",
                                    left: "-5%",
                                    borderRadius: "50%",
                                    background: "linear-gradient(135deg, rgb(160, 110, 0) 0%, rgb(120, 80, 0) 100%)",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 6,
                                }}
                            >
                                <span
                                    style={{
                                        fontFamily: "Bold",
                                        fontSize: getAdjustingFontSizeByHeightWidth(
                                            heightReference * 0.03,
                                            screen.width * 0.03,
                                            step.number.length,
                                            64
                                        ),
                                        color: "rgba(255, 240, 180, 1)",
                                        lineHeight: 1,
                                    }}
                                >
                                    {step.number}
                                </span>
                            </div>

                            {/* Card Content */}
                            <div
                                style={{
                                    flex: 1,
                                    opacity: isHovered ? 0 : 1,
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    paddingTop: "3%",
                                    paddingBottom: "6%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                }}
                            >
                                {/* Step Title */}
                                <div style={{ justifyContent: "center", alignItems: "center", marginBottom: "5%", marginTop: "5%", display: "flex" }}>
                                    <h2
                                        style={{
                                            height: 60,
                                            fontFamily: "Medium", alignItems: "center",  // ✅ vertically centers text within the 60px height
                                            fontSize: getAdjustingFontSizeByHeightWidth(
                                                heightReference * 0.06,
                                                screen.width * 0.25,
                                                steps[2].title.length,
                                                64
                                            ),
                                            padding: heightReference * 0.005,
                                            color: "rgba(51, 41, 0, 1)",
                                            display: "flex"
                                        }}
                                    >
                                        {step.title}
                                    </h2>
                                </div>
                                <div style={{
                                    height: heightReference * 0.25 * 2.02535,
                                    width: heightReference * 0.25,
                                }}>
                                    <FlexiblePhoneStillImage
                                        marginHorizontal={"3%"}
                                        marginTop={"1%"}
                                        image={step.image}
                                        videoBorderRadius={50 * (1920 * 0.2 / 400) * 0.5 + 50 * 0.5 * (getScreenSize().width) * 0.2 / 400}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export const HowItWorksSectionTablet: React.FC = () => {
    const screen = getScreenSize();
    const heightReference = Math.min(screen.height, screen.width);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const isAnimatingRef = useRef(false);

    useEffect(() => {
        navbarState.setHidden(expandedIndex !== null);
    }, [expandedIndex]);

    useEffect(() => {
        return () => navbarState.setHidden(false);
    }, []);

    // Lock / unlock body scroll when modal is open
    const savedScrollY = useRef(0);
    useEffect(() => {
        if (expandedIndex !== null) {
            savedScrollY.current = window.scrollY;
            document.body.style.position = "fixed";
            document.body.style.top = `-${savedScrollY.current}px`;
            document.body.style.width = "100%";
            document.body.style.overflowY = "scroll";
        } else {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.body.style.overflowY = "";
            window.scrollTo(0, savedScrollY.current);
        }
        return () => {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.body.style.overflowY = "";
        };
    }, [expandedIndex]);

    const steps = [
        {
            number: "1",
            title: "Play Deals",
            text: "Navigate thought-provoking deals with no time pressure",
            image: GamePlayScreenShot,
            video: gameScreen
        },
        {
            number: "2",
            title: "See Rank & Mistakes",
            text: "Instant ranking and solver evaluation of your play",
            image: DelighterStill,
            video: delighter
        },
        {
            number: "3",
            title: "Review Your Game",
            text: "Delve into analysis that is clear, organized and skill-level matched",
            image: ReviewScreen,
            video: resultsScreen,
            banner: beginnerBannerText
        }
    ];

    const isMobileOrTablet = false;
    const phoneBorderRadius = !isMobileOrTablet ? getScreenSize().height * 0.1 : 35;

    const videoRefs = useRef<(HTMLVideoElement | null)[]>([null, null, null]);
    const [videoKeys, setVideoKeys] = useState([0, 0, 0]);

    const handleVideoReplay = (index: number) => {
        const video = videoRefs.current[index];
        if (video) {
            video.currentTime = 0;
            video.play().catch(e => console.log("Video play failed:", e));
        }
    };

    useEffect(() => {
        if (expandedIndex !== null) {
            const timer = setTimeout(() => handleVideoReplay(expandedIndex), 100);
            return () => clearTimeout(timer);
        }
    }, [expandedIndex]);

    const handleCardTap = (index: number) => {
        if (isAnimatingRef.current) return;
        isAnimatingRef.current = true;
        setTimeout(() => { isAnimatingRef.current = false; }, 450);
        setExpandedIndex(index);
    };

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (isAnimatingRef.current) return;
        isAnimatingRef.current = true;
        setTimeout(() => { isAnimatingRef.current = false; }, 450);
        setExpandedIndex(null);
    };

    const fontBase = heightReference * 0.22;

    return (
        <div
            style={{
                width: "100%",
                height: heightReference * 0.97,
                minHeight: 450,
                paddingTop: "2%",
                justifyContent: "center",
                paddingBottom: "6%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "linear-gradient(180deg, rgb(255, 246, 210) 0%, rgb(255, 235, 160) 100%)",
                position: "relative",
            }}
        >
            <img
                src={isMobileOrTablet ? StoreCreativeBackgroundNarrow : StoreCreativeBackground}
                alt="Daily Tournament Tile"
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 0,
                }}
            />

            <h1
                style={{
                    fontFamily: "Bold",
                    fontSize: getAdjustingFontSizeByHeightWidth(
                        heightReference * 0.07,
                        screen.width * 0.6,
                        "Simple and Fun".length,
                        200
                    ),
                    color: "rgba(51, 41, 0, 1)",
                    marginTop: "3%",
                    marginBottom: "2%",
                    textAlign: "center",
                    WebkitTextStroke: isSafari ? "0.5px rgba(50, 50, 0, 0.6)" : null,
                    textShadow: isSafari ? null : "1px 1px 0px rgb(50, 50, 0)",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                Simple and Fun
            </h1>

            {/* Cards row */}
            <div
                style={{
                    width: getScreenSize().width > getScreenSize().height ? "80%" : "90%",
                    position: "relative",
                    display: "flex",
                    flexDirection: getIsMobile() ? "column" : "row",
                    justifyContent: "space-between",
                    gap: 0,
                    zIndex: 1,
                }}
            >
                {steps.map((step, index) => (
                    <div
                        key={index}
                        onClick={() => handleCardTap(index)}
                        style={{
                            flex: 1,
                            margin: "1%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 1,
                            cursor: "pointer",
                            WebkitTapHighlightColor: "transparent",
                        }}
                    >
                        {/* Card background */}
                        <div
                            style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                borderRadius: "24px",
                                background: "linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 60%, rgb(255, 240, 180) 100%)",
                                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04)",
                                border: "1px solid rgba(255,255,255,0.6)",
                            }}
                        />

                        {/* Number circle */}
                        <div
                            style={{
                                width: 1.5 * getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.03,
                                    screen.width * 0.03,
                                    step.number.length,
                                    64
                                ),
                                height: 1.5 * getAdjustingFontSizeByHeightWidth(
                                    heightReference * 0.03,
                                    screen.width * 0.03,
                                    step.number.length,
                                    64
                                ),
                                position: "absolute",
                                top: "-2%",
                                left: "-5%",
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, rgb(160, 110, 0) 0%, rgb(120, 80, 0) 100%)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 6,
                            }}
                        >
                            <span
                                style={{
                                    fontFamily: "Bold",
                                    fontSize: getAdjustingFontSizeByHeightWidth(
                                        heightReference * 0.03,
                                        screen.width * 0.03,
                                        step.number.length,
                                        64
                                    ),
                                    color: "rgba(255, 240, 180, 1)",
                                    lineHeight: 1,
                                }}
                            >
                                {step.number}
                            </span>
                        </div>

                        {/* Card content */}
                        <div
                            style={{
                                flex: 1,
                                position: "relative",
                                width: "100%",
                                paddingTop: "3%",
                                paddingBottom: "6%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            {/* Title */}
                            <div style={{
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: getScreenSize().height < 450 ? "0%" : "5%",
                                marginTop: "5%",
                                display: "flex",
                            }}>
                                <h2
                                    style={{
                                        height: 60,
                                        fontFamily: "Medium",
                                        fontSize: getAdjustingFontSizeByHeightWidth(
                                            heightReference * 0.06,
                                            screen.width * 0.25,
                                            steps[2].title.length,
                                            64
                                        ),
                                        padding: heightReference * 0.005,
                                        color: "rgba(51, 41, 0, 1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {step.title}
                                </h2>
                            </div>

                            {/* Still image */}
                            <div style={{
                                height: heightReference * 0.23 * 2.02535,
                                width: heightReference * 0.23,


                            }}>
                                <FlexiblePhoneStillImage
                                    marginHorizontal={"3%"}
                                    marginTop={"1%"}
                                    image={step.image}
                                    videoBorderRadius={(heightReference * 0.23) / 6}
                                />
                            </div>

                            {/* Play Video button — pill */}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 8,
                                    marginTop: "6%",
                                    background: "linear-gradient(145deg, rgba(255,248,200,1) 0%, rgba(255,225,120,0.95) 100%)",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.8)",
                                    border: "1.5px solid rgba(51, 41, 0, 0.2)",
                                    borderRadius: "999px",
                                    paddingTop: fontBase * 0.04,
                                    paddingBottom: fontBase * 0.04,
                                    paddingLeft: fontBase * 0.07,
                                    paddingRight: fontBase * 0.09,
                                }}
                            >
                                <svg
                                    width={fontBase * 0.085}
                                    height={fontBase * 0.085}
                                    viewBox="0 0 24 24"
                                    fill="rgba(51, 41, 0, 0.9)"
                                    style={{ marginLeft: "4%", flexShrink: 0 }}
                                >
                                    <polygon points="6,3 20,12 6,21" />
                                </svg>
                                <span style={{
                                    fontFamily: "Bold",
                                    fontSize: fontBase * 0.062,
                                    color: "rgba(51, 41, 0, 0.75)",
                                    letterSpacing: 0.8,
                                    textTransform: "uppercase",
                                    whiteSpace: "nowrap",
                                }}>
                                    Play Video
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Fullscreen video modals */}
            {steps.map((step, index) => {
                const isExpanded = expandedIndex === index;
                const fsPhoneHeight = screen.height > screen.width ? heightReference : heightReference * 0.8;
                const fsPhoneWidth = fsPhoneHeight / 2.02535;

                return (
                    <React.Fragment key={`modal-${index}`}>
                        {/* Dark backdrop */}
                        <div
                            onClick={handleClose}
                            style={{
                                position: "fixed",
                                inset: 0,
                                backgroundColor: "rgba(0,0,0,0.82)",
                                zIndex: 100,
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                            }}
                        />

                        {/* Phone centred in viewport */}
                        <div
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: isExpanded
                                    ? (getScreenSize().height < 450 ? "translate(-50%, -54%) scale(0.9)" : "translate(-50%, -54%) scale(1)")
                                    : "translate(-50%, -50%) scale(0.88)",
                                width: fsPhoneWidth,
                                height: fsPhoneHeight,
                                zIndex: 101,
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease, transform 0.38s cubic-bezier(0.34, 1.26, 0.64, 1)",
                            }}
                        >
                            <FlexiblePhone
                                style={{ width: "100%", height: "100%", position: "relative" }}
                                videoBorderRadius={phoneBorderRadius * 0.4}
                                marginHorizontal={"3%"}
                                marginTop={"1%"}
                                video={step.video}
                                videoRef={(ref) => videoRefs.current[index] = ref}
                                videoKey={videoKeys[index]}
                                banner={step.banner}
                            />
                        </div>

                        {/* Close button */}
                        {/* Top-right close button — positioned above phone frame */}
                        <div
                            onClick={handleClose}
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: isExpanded
                                    ? `translate(${fsPhoneWidth / 2 - 20}px, calc(-50% - ${fsPhoneHeight / 2 + 12}px))`
                                    : `translate(${fsPhoneWidth / 2 - 20}px, calc(-50% - ${fsPhoneHeight / 2 + 12}px))`,
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                background: "rgba(20,20,30,0.85)",
                                backdropFilter: "blur(10px)",
                                WebkitBackdropFilter: "blur(10px)",
                                border: "1px solid rgba(255,255,255,0.4)",
                                zIndex: 102,
                                cursor: "pointer",
                                WebkitTapHighlightColor: "transparent",
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <svg
                                width={14}
                                height={14}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="rgba(255,255,255,0.95)"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export const HowItWorksSectionMobile: React.FC = () => {
    const screen = getScreenSize();
    const heightReference = screen.height;
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const isAnimatingRef = useRef(false);

    useEffect(() => {
        navbarState.setHidden(expandedIndex !== null);
    }, [expandedIndex]);

    useEffect(() => {
        return () => navbarState.setHidden(false);
    }, []);

    // Lock / unlock body scroll when modal is open
    const savedScrollY = useRef(0);
    useEffect(() => {
        if (expandedIndex !== null) {
            savedScrollY.current = window.scrollY;
            document.body.style.position = "fixed";
            document.body.style.top = `-${savedScrollY.current}px`;
            document.body.style.width = "100%";
            document.body.style.overflowY = "scroll";
        } else {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.body.style.overflowY = "";
            window.scrollTo(0, savedScrollY.current);
        }
        return () => {
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.body.style.overflowY = "";
        };
    }, [expandedIndex]);

    const steps = [
        {
            number: "1",
            title: "Play Deals",
            text: "Navigate thought-provoking deals with no time pressure",
            image: GamePlayScreenShot,
            video: gameScreen
        },
        {
            number: "2",
            title: "See Rank & Mistakes",
            text: "Instant ranking & solver evaluation of your play",
            image: DelighterStill,
            video: delighter
        },
        {
            number: "3",
            title: "Review Your Game",
            text: "Delve into analysis that is clear, organized and skill-level matched",
            image: ReviewScreen,
            video: resultsScreen,
            banner: beginnerBannerText
        }
    ];

    const phoneBorderRadius = 35;
    const videoRefs = useRef<(HTMLVideoElement | null)[]>([null, null, null]);

    const handleVideoReplay = (index: number) => {
        const video = videoRefs.current[index];
        if (video) {
            video.currentTime = 0;
            video.play().catch(e => console.log("Video play failed:", e));
        }
    };

    useEffect(() => {
        if (expandedIndex !== null) {
            const timer = setTimeout(() => handleVideoReplay(expandedIndex), 100);
            return () => clearTimeout(timer);
        }
    }, [expandedIndex]);

    const handleCardTap = (index: number) => {
        if (isAnimatingRef.current) return;
        isAnimatingRef.current = true;
        setTimeout(() => { isAnimatingRef.current = false; }, 450);
        setExpandedIndex(index);
    };

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (isAnimatingRef.current) return;
        isAnimatingRef.current = true;
        setTimeout(() => { isAnimatingRef.current = false; }, 450);
        setExpandedIndex(null);
    };

    const collapsedHeight = heightReference * 0.16;  // shorter card
    // Font sizes stay pegged to a fixed reference, not the card height
    const fontBase = heightReference * 0.22;



    return (
        <div
            style={{
                width: "100%",
                paddingTop: "4%",
                paddingBottom: "6%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "linear-gradient(180deg, rgb(255, 246, 210) 0%, rgb(255, 235, 160) 100%)",
                position: "relative",
                boxSizing: "border-box",
            }}
        >
            {/* Section title */}
            <h1
                style={{
                    fontFamily: "Bold",
                    fontSize: getAdjustingFontSizeByHeightWidth(
                        heightReference * 0.1,
                        screen.width * 0.7,
                        "Simple and Fun".length,
                        200
                    ),
                    color: "rgba(51, 41, 0, 1)",
                    marginTop: "4%",
                    marginBottom: "8%",
                    textAlign: "center",
                    WebkitTextStroke: isSafari ? "0.5px rgba(50, 50, 0, 0.6)" : null,
                    textShadow: isSafari ? null : "1px 1px 0px rgb(50, 50, 0)",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                Simple and Fun
            </h1>

            {/* ── Collapsed cards list ── */}
            <div
                style={{
                    width: "88%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                {steps.map((step, index) => (
                    <div
                        key={index}
                        onClick={() => handleCardTap(index)}
                        style={{
                            width: "100%",
                            minHeight: collapsedHeight,
                            height: "auto",
                            borderRadius: "20px",
                            position: "relative",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            overflow: "visible",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.04)",
                            background: "linear-gradient(135deg, rgb(255, 250, 231) 0%, rgb(255, 252, 238) 60%, rgb(255, 240, 180) 100%)",
                            border: "1px solid rgba(255,255,255,0.6)",
                            cursor: "pointer",
                            WebkitTapHighlightColor: "transparent",
                            boxSizing: "border-box",
                            paddingTop: "2%",
                            paddingBottom: "2%",
                            paddingLeft: "4%",
                            paddingRight: "3%",
                        }}
                    >
                        {/* Number circle — absolutely positioned top-left */}
                        <div
                            style={{
                                position: "absolute",
                                top: -fontBase * 0.075,
                                left: -fontBase * 0.075,
                                width: fontBase * 0.2,
                                height: fontBase * 0.2,
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, rgb(160, 110, 0) 0%, rgb(120, 80, 0) 100%)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <span
                                style={{
                                    fontFamily: "Bold",
                                    fontSize: fontBase * 0.1,
                                    color: "rgba(255, 240, 180, 1)",
                                    lineHeight: 1,
                                }}
                            >
                                {step.number}
                            </span>
                        </div>

                        {/* Title + subtitle — now has full width minus phone/chevron */}
                        <div style={{ flex: 1, minWidth: 0, textAlign: "left", marginRight: "3%" }}>
                            <div
                                style={{
                                    fontFamily: "Bold",
                                    fontSize: getAdjustingFontSizeByHeightWidth(
                                        fontBase * 0.28,
                                        screen.width * 0.38,
                                        step.title.length,
                                        64
                                    ),
                                    color: "rgba(51, 41, 0, 1)",
                                    marginBottom: "5%",
                                }}
                            >
                                {step.title}
                            </div>
                            <div
                                style={{
                                    fontFamily: "Medium",
                                    fontSize: getAdjustingFontSizeByHeightWidth(
                                        fontBase * 0.45,
                                        screen.width * 0.48,
                                        step.text.length,
                                        48
                                    ),
                                    color: "rgba(80, 60, 0, 0.85)",
                                    lineHeight: 1.35,
                                }}
                            >
                                {step.text}
                            </div>
                        </div>

                        {/* Phone thumbnail */}
                        <div
                            style={{
                                height: collapsedHeight * 1.1,
                                width: (collapsedHeight * 1.1) / 2.02535,
                                flexShrink: 0,
                                overflow: "hidden",
                            }}
                        >
                            <FlexiblePhoneStillImage
                                marginHorizontal={"0%"}
                                marginTop={"0%"}
                                image={step.image}
                                videoBorderRadius={((collapsedHeight * 1.1) / 2.02535) / 6}
                            />
                        </div>

                        {/* Play button */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 5,
                                flexShrink: 0,
                                marginLeft: "2%",
                            }}
                        >
                            <div
                                style={{
                                    width: fontBase * 0.22,
                                    height: fontBase * 0.22,
                                    borderRadius: "50%",
                                    background: "linear-gradient(145deg, rgba(255,248,200,1) 0%, rgba(255,225,120,0.95) 100%)",
                                    boxShadow: "1px 1px 4px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.8)",
                                    border: "1.5px solid rgba(51, 41, 0, 0.2)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <svg
                                    width={fontBase * 0.085}
                                    height={fontBase * 0.085}
                                    viewBox="0 0 24 24"
                                    fill="rgba(51, 41, 0, 0.9)"
                                    style={{ marginLeft: "8%" }} // optical centre for play triangle
                                >
                                    <polygon points="6,3 20,12 6,21" />
                                </svg>
                            </div>
                            <span style={{
                                fontFamily: "Bold",
                                fontSize: fontBase * 0.05,
                                color: "rgba(51, 41, 0, 0.65)",
                                letterSpacing: 0.8,
                                textTransform: "uppercase",
                                lineHeight: 0.5
                            }}>
                                {"Play"}
                            </span>
                            <span style={{
                                fontFamily: "Bold",
                                fontSize: fontBase * 0.05,
                                color: "rgba(51, 41, 0, 0.65)",
                                letterSpacing: 0.8,
                                textTransform: "uppercase", lineHeight: 0.5
                            }}>
                                {"video"}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {/* ── Fullscreen phone overlays — no card, just phone + X ── */}
            {steps.map((step, index) => {
                const isExpanded = expandedIndex === index;

                // Phone sized to fill viewport height with small top/bottom margin
                const fsPhoneHeight = heightReference * 0.76;
                const fsPhoneWidth = fsPhoneHeight / 2.02535;

                return (
                    <React.Fragment key={`modal-${index}`}>
                        {/* Dark backdrop — tap to close */}
                        <div
                            onClick={handleClose}
                            style={{
                                position: "fixed",
                                inset: 0,
                                backgroundColor: "rgba(0,0,0,0.82)",
                                zIndex: 100,
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                            }}
                        />

                        {/* Phone — centred in viewport, no surrounding card */}
                        <div
                            style={{
                                position: "fixed",
                                top: fsPhoneHeight / 2 + 10,
                                left: "50%",
                                transform: isExpanded
                                    ? "translate(-50%, " + (fsPhoneHeight / 2) + ") scale(1)"
                                    : "translate(-50%, -50%) scale(0.88)",
                                width: fsPhoneWidth,
                                height: fsPhoneHeight,
                                maxHeight: "100vh",
                                maxWidth: "49.37vh",
                                zIndex: 101,
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease, transform 0.38s cubic-bezier(0.34, 1.26, 0.64, 1)",
                            }}
                        >
                            <FlexiblePhone
                                style={{ width: "100%", height: "100%", position: "relative" }}
                                videoBorderRadius={phoneBorderRadius}
                                marginHorizontal={"3%"}
                                marginTop={"1%"}
                                video={step.video}
                                videoRef={(ref) => videoRefs.current[index] = ref}
                                videoKey={0}
                                banner={step.banner}
                            />

                        </div>

                        {/* Bottom-center close button */}
                        {/* Top-right close button — positioned above phone frame */}
                        <div
                            onClick={handleClose}
                            style={{
                                position: "fixed",
                                top: heightReference * 0.5 - fsPhoneHeight / 2 - 44,
                                left: "50%",
                                transform: `translateX(${fsPhoneWidth / 2 - 20}px)`,
                                width: 36,
                                height: 36,
                                borderRadius: "50%",
                                background: "rgba(20,20,30,0.85)",
                                backdropFilter: "blur(10px)",
                                WebkitBackdropFilter: "blur(10px)",
                                border: "1px solid rgba(255,255,255,0.4)",
                                zIndex: 102,
                                cursor: "pointer",
                                WebkitTapHighlightColor: "transparent",
                                opacity: isExpanded ? 1 : 0,
                                pointerEvents: isExpanded ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <svg
                                width={14}
                                height={14}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="rgba(255,255,255,0.95)"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};